import React from "react";

import { makeStyles } from "@material-ui/core";
import Message from "@sendbird/uikit-react/Channel/components/Message";
import { ReactComponent as PatientProfileImg } from "../../img/patientProfile.svg";
import "@sendbird/uikit-react/dist/index.css";
import { ReactComponent as DoctorProfileImg } from "../../img/drProfile.svg";
import AdminProfileImg from "../../img/receptionist.png";
import FileViewer from "@sendbird/uikit-react/Channel/components/FileViewer";
import moment from "moment";
import { useState } from "react";
import { useEffect } from "react";

const millisecondsToDate = (milliseconds) => {
  if (
    moment(milliseconds).format("DD/MM/YYYY") == moment().format("DD/MM/YYYY")
  ) {
    return "TODAY";
  } else if (
    moment(milliseconds).format("DD/MM/YYYY") ==
    moment().subtract(1, "days").format("DD/MM/YYYY")
  ) {
    return "YESTERDAY";
  } else return moment(milliseconds).format("DD/MM/YYYY");
};

function millisecondsToTime(milliseconds) {
  const time = moment(milliseconds);
  return time.format("LT");
}

const MessageView = ({
  message,
  isDoctorsMessage,
  previousDate,
  isFile,
  url,
  messageObj,
  isAdmin,
}) => {
  const useStyles = makeStyles((theme) => ({
    messageComponentParent: {
      display: "flex",
      flexDirection: isDoctorsMessage ? "row-reverse" : "row",
      width: "100%",
    },
    senderProfileParent: {
      // backgroundColor: isDoctorsMessage ? "#E1FCE3" : "#E1F1FD",
      height: "35px",
      width: "35px",
      marginTop: "0px",
      marginRight: isDoctorsMessage ? "0px" : "10px",
      marginLeft: isDoctorsMessage ? "10px" : "0px",
    },
    messageParent: {
      width: "100%",
      marginBottom: "10px",
      paddingBottom: "20px",
      backgroundColor: isDoctorsMessage ? "#E1FCE3" : "#E1F1FD",
      borderRadius: "4px",
      position: "relative",
    },
    message: {
      width: "100%",
      height: "fit-content",
      resize: "none",

      padding: "10px",
    },
    messageTime: {
      font: "normal normal normal 11px Segoe UI",
      position: "absolute",
      right: "10px",
      bottom: "10px",
    },
    messageComponentRightSection: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
    },
    adminProfileBG: {
      backgroundColor: "var(--lightbluecolrtwenty)",
      borderRadius: "50%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  }));
  const classes = useStyles();

  const [isShowDate, setIsShowDate] = useState(false);

  useEffect(() => {
    if (
      previousDate.current === undefined ||
      previousDate.current !== millisecondsToDate(message.date)
    ) {
      setIsShowDate(true);
    }
    previousDate.current = millisecondsToDate(message.date);
  }, []);

  return (
    <>
      {isShowDate && (
        <div
          style={{
            margin: "10px auto",
            width: "fit-content",
            font: "normal normal normal 14px Segoe UI",
          }}
        >
          {millisecondsToDate(message.date)}
        </div>
      )}

      {isFile ? (
        <div className={classes.message}>
          <Message
            renderMessage={(param) => {
              console.log(param);
            }}
            message={messageObj}
          />
        </div>
      ) : (
        <div className={classes.messageComponentParent}>
          <div className={classes.senderProfileParent}>
            {isDoctorsMessage ? (
              messageObj?.sender?.plainProfileUrl ? (
                <img
                  style={{ height: "100%", width: "100%", borderRadius: "50%" }}
                  src={messageObj.sender.plainProfileUrl}
                />
              ) : isAdmin ? (
                <div className={classes.adminProfileBG}>
                  <img style={{ height: "80%" }} src={AdminProfileImg} />
                </div>
              ) : (
                <DoctorProfileImg style={{ height: "100%", width: "100%" }} />
              )
            ) : (
              <PatientProfileImg style={{ height: "100%", width: "100%" }} />
            )}
          </div>

          <div className={classes.messageComponentRightSection}>
            <div className={classes.messageParent}>
              <p className={classes.message}>
                {message.text?.split("\n").map((str) => (
                  <p>{str}</p>
                ))}
              </p>

              <p className={classes.messageTime}>
                {millisecondsToTime(message.date)}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MessageView;
